import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, cn } from '@wit-support/ui';
import { preliminaryHint, verdictLabel } from '../verdict.js';
const VARIANT = {
    yes: 'success',
    unclear: 'warning',
    no: 'danger',
    none: 'neutral',
};
/**
 * Бейдж вывода: «Скорее да / Неясно / Скорее нет / Мало покупок». Предварительный
 * вывод (меньше 184 покупок) — пунктирный бейдж и «предв.» рядом.
 */
export function VerdictBadge({ verdict, preliminary = false, hint, size = 'sm', className, early, }) {
    const isEarly = verdict === null && !!early;
    const prelim = preliminary && verdict !== null;
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1.5 whitespace-nowrap', className), children: [_jsx(Badge, { variant: VARIANT[verdict ?? 'none'], size: size, title: (isEarly ? early : hint) ?? undefined, "data-verdict": isEarly ? 'early' : (verdict ?? 'none'), className: cn(prelim && 'border border-dashed border-current'), children: isEarly ? 'Ещё рано' : verdictLabel(verdict) }), prelim ? (_jsx("span", { className: "text-xs text-[var(--color-text-muted)]", title: hint ?? undefined, children: "\u043F\u0440\u0435\u0434\u0432." })) : null] }));
}
/** Бейдж по группе отчёта (с подсказкой «предварительно: N из 184 покупок»). */
export function GroupVerdictBadge({ group, size, }) {
    return (_jsx(VerdictBadge, { verdict: group.answer.verdict, preliminary: group.answer.preliminary, hint: preliminaryHint(group), ...(size ? { size } : {}) }));
}
//# sourceMappingURL=verdict-badge.js.map